var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',[_vm._v("Copyright")]),_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" Todos los derechos reservados")])]),_c('div',{staticClass:"mfs-auto"})])}
var staticRenderFns = []

export { render, staticRenderFns }